import { getPrices } from '@components/Results/Components/Itinerary/ResultsItineraryPrice/ResultsItineraryDualPrice';

const DISCOUNT_THRESHOLD = 10;

export const getDiscount = ({ fees }) => {
  const { primePrice, noPrimePrice } = getPrices(fees);
  return Math.floor(
    ((noPrimePrice?.amount - primePrice?.amount) / noPrimePrice?.amount) *
      100 || 0
  );
};

export const hasDiscountPillShow = ({ itineraries }) => {
  return (
    itineraries.filter(
      (itinerary) => getDiscount(itinerary) >= DISCOUNT_THRESHOLD
    ).length > 0
  );
};

export const hasDiscountPillShouldShow = ({ itineraries }) => {
  return (
    itineraries.filter(
      (itinerary) => getDiscount(itinerary) > DISCOUNT_THRESHOLD
    ).length > 0
  );
};
